import PayableExpenseItemsEditor from './PayableExpenseItemsEditor';

export default {
  PayableExpenseItemsEditor,
};
